import { getTokenApiManager } from "./getTokenApiManager";
import { requestApiManager } from "./requestApiManager";
import { b64EncodeUnicode } from "../utils/b64EncodeUnicode";


export const requestWithAuthApiManager = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {

      const token = response?.data?.token
      const auth = b64EncodeUnicode(JSON.stringify({ token }));
      localStorage.setItem('ECCO_IND_AUTH', auth);

      return requestApiManager({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error);
    });
};